import { render } from "./Donate.vue?vue&type=template&id=7932c0f5"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__